import { render } from "./RecipeImg.vue?vue&type=template&id=6c329b69"
import script from "./RecipeImg.vue?vue&type=script&lang=js"
export * from "./RecipeImg.vue?vue&type=script&lang=js"

import "./RecipeImg.vue?vue&type=style&index=0&id=6c329b69&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__